/**
 * @file Form.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Wednesday, 17th July 2019 10:20:50 am
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 */
import type { ID } from 'web-panel-essentials/types'
import type { iForm, iExposedView } from '../../types'

import { CAST } from 'web-panel-essentials/misc'
import * as React from 'react'

class Form<T, S> extends React.Component<T, S> implements iForm {
  handleElementChange = (event: any) : void => {
    const { id, name, value } = event.target
    if ((this.props:any).onDataChanged) (this.props:any).onDataChanged(name || id, value)
  }

  handleNumericElementChange = (event: any) : void => {
    const { id, name, value } = event.target

    if (!isNaN(value) && (this.props:any).onDataChanged) (this.props:any).onDataChanged(name || id, CAST.String(value).trim())
  }

  handleComponentChange = (valuePath: string, changes: Object, id: ?ID, collection: ?string) : void => {
    if ((this.props:any).onDataChanged) (this.props:any).onDataChanged(valuePath, changes, id, collection)
  }

  handleCommit = (fieldName: string, id: ?ID, collection: ?string) => {
    if ((this.props:any).onCommit) (this.props:any).onCommit(fieldName, id, collection)
  }
}

class PureForm<T> extends React.PureComponent<T> implements iForm {
  handleElementChange = (event: any) : void => {
    const { id, name, value } = event.target
    if ((this.props:any).onDataChanged) (this.props:any).onDataChanged(name || id, value)
  }

  handleNumericElementChange = (event: any) : void => {
    const { id, name, value } = event.target

    if (!isNaN(value) && (this.props:any).onDataChanged) (this.props:any).onDataChanged(name || id, CAST.String(value).trim())
  }

  handleComponentChange = (valuePath: string, changes: Object, id: ?ID, collection: ?string) : void => {
    if ((this.props:any).onDataChanged) (this.props:any).onDataChanged(valuePath, changes, id, collection)
  }

  handleCommit = (fieldName: string, id: ?ID, collection: ?string) => {
    if ((this.props:any).onCommit) (this.props:any).onCommit(fieldName, id, collection)
  }
}

function StatefullForm (WrappedForm: any) {
  return class extends React.Component<any, any> implements iExposedView<any> {
    constructor (props: any) {
      super(props)
      this.state = props.initialState
    }

    async data () : Promise<any> {
      return this.state
    }

    async command () {

    }

    handleElementChange = (event: any) : void => {
      const { id, name, value } = event.target
      this.setState({ [id || name]: value })
    }

    handleComponentChange = (valuePath: string, changes: Object) : void => {
      this.setState({ [valuePath]: changes })
    }

    render () : React.Node {
      return <WrappedForm onElementChange={this.handleElementChange} onComponentChange={this.handleComponentChange} {...this.state} />
    }
  }
}

export { Form, PureForm, StatefullForm }
